module.exports = __webpack_public_path__ + "img/thank0.f30b7770.gif";